// removed by extract-text-webpack-plugin
module.exports = {"toolbar":"Toolbar__toolbar__2pT8n"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Common/Toolbar/Toolbar.scss
// module id = 1625
// module chunks = 0